const guiColors = {
    'motion-primary': 'hsla(38, 100%, 55%, 1)',
    'motion-primary-transparent': 'hsla(38, 100%, 55%, 0.9)',
    'motion-tertiary': 'hsla(38, 80%, 45%, 1)',

    'looks-secondary': 'hsla(38, 100%, 55%, 1)',
    'looks-transparent': 'hsla(38, 100%, 55%, 0.35)',
    'looks-light-transparent': 'hsla(38, 100%, 55%, 0.15)',
    'looks-secondary-dark': 'hsla(38, 80%, 45%, 1)',

    'extensions-primary': 'hsla(48, 85%, 55%, 1)',
    'extensions-tertiary': 'hsla(48, 85%, 30%, 1)',
    'extensions-transparent': 'hsla(48, 85%, 55%, 0.35)',
    'extensions-light': 'hsla(48, 57%, 75%, 1)',

    'drop-highlight': 'hsl(38, 100%, 68%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(38, 100%, 55%)',
    checkboxActiveBorder: 'hsl(38, 80%, 45%)'
};

export {
    guiColors,
    blockColors
};